/** The HTTP status of a failed request, or undefined when the failure had no response. */
export const statusOf = (error: unknown): number | undefined => {
  const status = (error as { response?: { status?: unknown } } | undefined)?.response?.status;
  return typeof status === 'number' ? status : undefined;
};

/**
 * The machine code on a mapped person-api error body (`errorCode`), which person-api supplies once
 * PR 2104 is deployed, or undefined when the failure had no response, no body, or no string code.
 * Read raw from the body: the generated client does not type an error body. Never throws.
 */
export const errorCodeOf = (error: unknown): string | undefined => {
  const errorCode = (error as { response?: { data?: { errorCode?: unknown } } } | undefined)
    ?.response?.data?.errorCode;
  return typeof errorCode === 'string' ? errorCode : undefined;
};
